import { useEffect } from "react";

/** Set `<title>`, description and canonical URL for the current page. Crawlers
 * that run scripts and browser tabs see them; the build also writes the same
 * values into each page's static HTML (see vite.config.ts). */
export function useDocumentMeta(meta: {
  title: string;
  description: string;
  path: string;
}): void {
  const { title, description, path } = meta;
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta(
      'link[rel="canonical"]',
      "href",
      `${window.location.origin}${path}`,
    );
  }, [title, description, path]);
}

function setMeta(selector: string, attribute: string, value: string): void {
  const element = document.head.querySelector(selector);
  if (element) element.setAttribute(attribute, value);
}
